module.exports = "<tr class=\"table-row\">\n\t<th>{{ label }}</th>\n\n\t<td><slot></slot></td>\n</tr>\n"